import { Result, type ResultProps } from '@common/ui/Result';

export type MatchmakerResultProps = Omit<ResultProps, 'src'> & {
  testId: string;
  icon3d: string;
};

/** A full-screen state (`Result`) with a 3D icon and its own test id. */
export const MatchmakerResult = ({
  testId,
  icon3d,
  ...props
}: MatchmakerResultProps) => {
  return (
    <div data-test-id={testId} style={{ display: 'flex', flex: 1 }}>
      <Result
        src={`/icons/3d-icons/${icon3d}`}
        iconContainerBg="var(--premium-secondary-transparent)"
        {...props}
      />
    </div>
  );
};
